import { Box, Typography } from "@mui/material";

type StatusBarTransactionProps = {
  status: 'SUCCESS' | 'EXPIRED' | 'VOID' | 'FAIL' | 'START' | 'PENDING' | string;
};

export const StatusBarTransaction = ({status}: StatusBarTransactionProps) => {

  let bgColor;
  let borderColor;
  let textColor;
  let text;

  switch(status) {
    case 'SUCCESS':
      bgColor = "success.extraLighter";
      borderColor = "#00B0A6";
      textColor = "success.main";
      text = 'Başarılı';
      break;

    case 'EXPIRED':
      bgColor = "warning.extraLighter";
      borderColor = "#ffb800"; 
      textColor = "warning.main"; 
      text = 'Süresi Doldu';
      break;

    case 'VOID':
      bgColor = "error.extraLighter";
      borderColor = "#ff0000";
      textColor = "error.main";
      text = 'İptal İşlemi Yapıldı';
      break;

    case 'FAIL':
      bgColor = "error.extraLighter";
      borderColor = "#ff0000";
      textColor = "error.main";
      text = 'Hata Aldı';
      break;

    case 'START':
      bgColor = "info.extraLighter";
      borderColor = "#17a2b8";
      textColor = "info.main";
      text = 'Başladı';
      break;

    case 'PENDING':
      bgColor = "secondary.extraLighter";
      borderColor = "#d39e00";
      textColor = "secondary.main";
      text = 'Bekliyor';
      break;

    default: 
      bgColor = "grey.200";
      borderColor = "#ccc";
      textColor = "text.primary";
      text = 'Bilinmiyor';
      break;
  }

  return (
    <Box sx={{textAlign: 'center', width: "100%",maxWidth:"200px", borderRadius: 2, backgroundColor: bgColor, border: `1px solid ${borderColor}`}}>
      <Typography variant="overline" color={textColor}>{text}</Typography>
    </Box>
  );
}
